/* unplugin-vue-components disabled */import { render } from "./EmojiSelector.vue?vue&type=template&id=05f0b634&scoped=true"
import script from "./EmojiSelector.vue?vue&type=script&lang=js"
export * from "./EmojiSelector.vue?vue&type=script&lang=js"

import "./EmojiSelector.vue?vue&type=style&index=0&id=05f0b634&lang=scss&scoped=true"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f0b634"]])

export default __exports__